import styled from 'styled-components';

export const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid rgb(222, 226, 230);
    margin-bottom: 10px;
    border-radius: 5px;
`;

export const CardContent = styled.div`
    padding: 10px;
`;

export const CardTabulatedData = styled.div`
    width: 100%;
    margin-bottom: 10px;
`;

export const Buttons = styled.div`
    border-top: 1px solid #dee2e6;
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
`;

export const CardSimpleData = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0px 8px;
    padding-bottom: 8px;
    color: #74777a;
    margin-bottom: 10px;
    border-bottom: 1px solid #dee2e6;
`;

export const CardApprovalData = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0px 8px;
    color: #74777a;
    font-weight: 550;
`;

export const CardData = styled.div``;

export const TableHeaderRecipe = styled.thead``;

export const TableBodyRecipe = styled.tbody``;

interface ITableColumnRecipeProps {
    width?: string;
    textAlign?: string;
}

export const TableColumnHeaderRecipe = styled.th<ITableColumnRecipeProps>`
    width: ${props => props.width || 'auto'};
    max-width: ${props => props.width || 'auto'};
    text-align: ${props => props.textAlign || 'left'};
`;

export const TableColumnBodyRecipe = styled.td<ITableColumnRecipeProps>`
    width: ${props => props.width || 'auto'};
    max-width: ${props => props.width || 'auto'};
    text-align: ${props => props.textAlign || 'left'};
`;

export const TableRowRecipe = styled.tr``;